<template>
  <div>
    <v-layout row wrap v-if="app_id > 0">
      <v-flex xs12>
        <div class="dropbox">
          <input class="input-file" type="file" @change="getFiles" />
          <p v-if="uploadList.length == 0" class="extra-margin"
            >Drag file to upload or click to browse</p
          >
          <div v-if="uploadList.length > 0" class="extra-margin">
            <p class="uploadList" v-for="(item, index) in items" :key="index">{{
              item.name
            }}</p>
          </div>
        </div>
        <br />
        <v-btn color="primary" @click="_addDoc" :disabled="saving"
          >Upload Files</v-btn
        >
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex xs12 class="font-italic"
        >You will be able to upload documents after saving the
        application.</v-flex
      >
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    type: String,
    app_id: Number,
  },
  data() {
    return {
      uploadList: [],
      items: [],
      saving: false,
    }
  },
  created() {},
  computed: {},
  methods: {
    _addDoc() {
      const self = this
      this.saving = true
      for (let i = 0; i < this.uploadList.length - 2; i++) {
        let file = this.uploadList[i]
        let fileReader = new FileReader()
        if (fileReader && file) {
          fileReader.readAsDataURL(file)
          fileReader.onload = function () {
            let contents = fileReader.result.split(',')[1]
            let obj = {
              Name: file.name,
              Type: file.type,
              ApplicationID: self.app_id,
              AppDocType: self.type,
              Contents: contents,
            }
            console.log(obj)
            axios
              .post(`/Documents`, obj)
              .then(function (response) {
                self.$emit('upload', response.data)
              })
              .catch(function (error) {
                console.log(error)
                this.errorText = error.response.data
                this.snackbar = true
              })
          }
        }
      }
      this.saving = false
      this.uploadList = []
      this.items = []
    },
    getFiles: function (event) {
      this.uploadList = []
      for (let file in event.target.files) {
        this.uploadList.push(event.target.files[file])
      }
      for (let i = 0; i < this.uploadList.length - 2; i++) {
        if (this.uploadList[i].name) this.items.push(this.uploadList[i])
      }
    },
  },
  watch: {},
  components: {},
}
</script>
<style scoped></style>
